import { VacanciesLayout } from "@features/layout";

export const VacanciesPage = () => {
  return <VacanciesLayout />;
};
